import { everestApi } from "../api"
import { API_CUSTOMER_PRICE_LEVELS } from "../ApiConstants"

type EverestCustomerPriceLevel = {
  customerPriceLevelId?: string | number
  CustomerPriceLevelId?: string | number
  customerPriceLevel?: string | number
  CustomerPriceLevel?: string | number
  description?: string
  Description?: string
  [key: string]: unknown
}

type CustomerPriceLevel = {
  customerPriceLevelId: string
  description: string
} & Record<string, unknown>

const normalizeCustomerPriceLevel = (
  response: EverestCustomerPriceLevel,
): CustomerPriceLevel => {
  const customerPriceLevelId =
    response.customerPriceLevelId ??
    response.CustomerPriceLevelId ??
    response.customerPriceLevel ??
    response.CustomerPriceLevel ??
    ""

  const description =
    response.description ??
    response.Description ??
    String(customerPriceLevelId ?? "")

  return {
    ...response,
    customerPriceLevelId: String(customerPriceLevelId ?? ""),
    description: String(description ?? ""),
  }
}

const normalizeResponse = (response: unknown): CustomerPriceLevel[] => {
  if (Array.isArray(response)) {
    return response.map((item) => normalizeCustomerPriceLevel(item))
  }

  if (response && typeof response === "object") {
    return [normalizeCustomerPriceLevel(response as EverestCustomerPriceLevel)]
  }

  return []
}

const customerPriceLevelApi = everestApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerPriceLevels: builder.query<
      CustomerPriceLevel[],
      { dealerGuid: string }
    >({
      query: ({ dealerGuid }) => ({
        url: `${API_CUSTOMER_PRICE_LEVELS}/${encodeURIComponent(dealerGuid)}`,
        method: "GET",
      }),
      transformResponse: normalizeResponse,
    }),

    addCustomerPriceLevel: builder.mutation<
      any,
      { dealerGuid: string; body: any }
    >({
      query: ({ dealerGuid, body }) => ({
        url: `${API_CUSTOMER_PRICE_LEVELS}/${encodeURIComponent(dealerGuid)}`,
        method: "POST",
        body,
      }),
    }),

    deleteCustomerPriceLevel: builder.mutation<
      any,
      { dealerGuid: string; customerPriceLevelId: string | number }
    >({
      query: ({ dealerGuid, customerPriceLevelId }) => ({
        url: `${API_CUSTOMER_PRICE_LEVELS}/${encodeURIComponent(dealerGuid)}/${encodeURIComponent(customerPriceLevelId)}`,
        method: "DELETE",
      }),
    }),
  }),
})

export const {
  useGetCustomerPriceLevelsQuery: useGetCustomerPriceLevelQuery,
  useAddCustomerPriceLevelMutation,
  useDeleteCustomerPriceLevelMutation,
} = customerPriceLevelApi
